//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------



//  -- List books ----------------
export const listBooks = () => ({ type: ActionTypes.books.listBooks });
export const listBooksFail = (returnedPayload) => ({
  type: ActionTypes.books.listBooksFail,
  payload: returnedPayload,
});
export const listBooksSuccess = (returnedPayload) => ({
  type: ActionTypes.books.listBooksSuccess,
  payload: returnedPayload,
});

//  -- List All books ----------------
export const listAllBooks = () => ({ type: ActionTypes.books.listAllBooks });
export const listAllBooksFail = (returnedPayload) => ({
  type: ActionTypes.books.listAllBooksFail,
  payload: returnedPayload,
});
export const listAllBooksSuccess = (returnedPayload) => ({
  type: ActionTypes.books.listAllBooksSuccess,
  payload: returnedPayload,
});

export const createBooks = () => ({ type: ActionTypes.books.createBook });
export const createBooksSuccess = (returnedPayload) => ({
  type: ActionTypes.books.createBookSuccess,
  payload: returnedPayload,
});

export const updateBooks = () => ({ type: ActionTypes.books.updateBook });
export const updateBooksSuccess = (returnedPayload) => ({
  type: ActionTypes.books.updateBookSuccess,
  payload: returnedPayload,
});
export const setBookOrder = (returnedPayload) => ({
  type: ActionTypes.books.setBookOrder,
  payload: returnedPayload,
});
export const setBookOrderFail = (returnedPayload) => ({
  type: ActionTypes.books.setBookOrderFail,
  payload: returnedPayload,
});
export const setBookOrderSuccess = (returnedPayload) => ({
  type: ActionTypes.books.setBookOrderSuccess,
  payload: returnedPayload,
});
export const setUserAllowedBooks = (returnedPayload) => ({
  type: ActionTypes.userBooks.setUserAllowedBooks,
  payload: returnedPayload,
});
export const listBooksByIdsSuccess = (returnedPayload) => ({
  type: ActionTypes.books.listBooksByIdsSuccess,
  payload: returnedPayload,
});

export const listBooksCover = () => ({ type: ActionTypes.books.listBooksCover });
export const listBooksCoverFail = (returnedPayload) => ({
  type: ActionTypes.books.listBooksCoverFail,
  payload: returnedPayload,
});
export const listBooksCoverSuccess = (returnedPayload) => ({
  type: ActionTypes.books.listBooksCoverSuccess,
  payload: returnedPayload,
});